module.exports = __webpack_public_path__ + "img/NG Reject Conveyor.df869d48.jpg";